import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { useFormFieldControl } from "../FormField/FormFieldContext.js";
/* empty css           */
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Select/Select.tsx
/**
* A native `<select>` styled like Input, with a chevron. `className` goes on the wrapper;
* every other prop, and the ref, go to the `<select>`.
*/
var Select = forwardRef(function Select({ size = "md", options, placeholder, invalid: invalidProp, disabled, className, children, value, defaultValue, id: idProp, "aria-describedby": describedByProp, ...rest }, ref) {
	const { id, "aria-describedby": describedBy, invalid } = useFormFieldControl({
		id: idProp,
		"aria-describedby": describedByProp,
		invalid: invalidProp
	});
	const startOnPlaceholder = placeholder != null && value === void 0 && defaultValue === void 0;
	return /* @__PURE__ */ jsxs("div", {
		className: cx("ds-select", `ds-select--${size}`, invalid && "ds-select--invalid", disabled && "ds-select--disabled", className),
		children: [/* @__PURE__ */ jsxs("select", {
			ref,
			className: "ds-select__field",
			id,
			disabled,
			"aria-invalid": invalid || void 0,
			"aria-describedby": describedBy,
			value,
			defaultValue: startOnPlaceholder ? "" : defaultValue,
			...rest,
			children: [placeholder != null && /* @__PURE__ */ jsx("option", {
				className: "ds-select__placeholder",
				value: "",
				disabled: true,
				children: placeholder
			}), options ? options.map((option) => /* @__PURE__ */ jsx("option", {
				value: option.value,
				disabled: option.disabled,
				children: option.label
			}, option.value)) : children]
		}), /* @__PURE__ */ jsx(Icon, {
			name: "chevron-down",
			className: "ds-select__chevron"
		})]
	});
});
//#endregion
export { Select };

//# sourceMappingURL=Select.js.map